import Footer from 'components/Footers/Footer';
import Navbar from 'components/Navbars/IndexNavbar';
import React, { useState,useRef,useEffect } from 'react';
import Swal from 'sweetalert2';
import BASE_URL from 'components/BaseUrl/apiConfig';
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';

const EmailVerification = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState();

    const userNameInputRef = useRef(null);


    useEffect(() => {
        // Focus on the userName input when the component mounts
        userNameInputRef.current.focus();
      }, []); 

    const handleButtonClick = async () => {
        try {
            
            // Validation: Check if the email is valid
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                // throw new Error('Please enter a valid email address.');
                await Swal.fire({
                    icon: 'error',
                    title: 'Something went wrong.',
                    text: 'Please enter a valid email address.',
                    showConfirmButton: true,
                });
                return; // Stop further execution if the email is not valid
            }

            // Show confirmation dialog
            const result = await Swal.fire({
                title: 'Confirmation!',
                text: `Are you sure you want to send the verification email to ${email}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Send',
            });

            // If the user confirms, send the email
            if (result.isConfirmed) {
                setLoading(true);
                const apiUrl = `${BASE_URL}/api/Users/UserVerify`;

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ emailId: email }),
                });

                if (response.ok) {
                    const button = document.getElementById('btnVerify');
                    const responseData = await response.json();
                    setLoading(false);
                    // Handle success
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: responseData.msg,
                        showConfirmButton: true,
                    });

                    button.innerHTML = ' Resend verification Email';

                    

                } else {
                    setLoading(false);
                    // Handle failure
                    await Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to send email verification link. Please try again later.',
                        showConfirmButton: true,
                    });
                    
                }
            }
        } catch (error) {
            // Handle any other errors
            console.error('Error:', error.message);
        }
    };

    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <BlockUiOverlay visible={loading} />
                <div className="container mx-auto mt-8 p-4">
                    <h1 className="text-2xl uppercase font-bold">Verify your email</h1>
                </div>
                <div className="container mx-auto p-4 flex flex-col items-center">
                    <form className="flex border p-5 items-center">
                        <label htmlFor="email" className="block text-sm flex uppercase font-medium text-gray-700">
                            Enter Register Email Address
                        </label>
                        <input
                            type="text"
                            id="email"
                            name="email"
                            value={email}
                            ref={userNameInputRef}
                            maxLength={50}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 p-2 border rounded-md ml-2"
                            style={{ width: '300px' }}
                        />

                        <button
                            type="button"
                            id="btnVerify"
                            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 ml-2"
                            onClick={handleButtonClick}
                        >
                            Send verification Email
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default EmailVerification;
